// import "./markup-menu";
import $ from 'jquery'
// import intlTelInput from 'intl-tel-input'
import sliders from './components/sliders'
import daterangepicker from 'daterangepicker'
import Select from './components/select'
global.$ = global.jQuery = $
require("./components/open-close");
document.addEventListener("DOMContentLoaded", () => {
  let currentStep = 1;
  $(".next-btn").click(function() {
    event.preventDefault(); // Останавливаем стандартное действие кнопки
    // Переходим к следующему шагу
    $('div[class*="feedback__step-"]').removeClass('active');
    $(`.feedback__step-${++currentStep}`).addClass('active');
    $('.feedback__line li.active').addClass('success');
    $('.feedback__line li.active').next().addClass('active');

  });
  if ($(window).width() < 1250) {
    $(".header .get").appendTo(".nav");
  }
  document.querySelectorAll('input[type="tel"]').forEach(function(input) {
      input.addEventListener("input", function () {
          this.value = this.value.replace(/[^0-9]/g, "");
      });
  });
  function scrollToTarget(target) {
      const headerOffset = 130; // высота фиксированного хедера
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
      });
  }

  const navLinks = document.querySelectorAll('.nav a[href^="#"]');

  // Клик по ссылке
  navLinks.forEach(link => {
      link.addEventListener('click', function(e) {
          e.preventDefault();
          $('.nav').removeClass('show');

          // убираем active со всех
          document.querySelectorAll('.nav li').forEach(li => li.classList.remove('active'));

          // добавляем active на родителя текущей ссылки
          this.closest('li').classList.add('active');

          // скроллим к блоку
          const targetId = this.getAttribute('href').substring(1);
          const target = document.getElementById(targetId);
          if (target) scrollToTarget(target);
      });
  });

  // Отслеживание скролла
  window.addEventListener('scroll', () => {
      let current = '';
      document.querySelectorAll('section[id]').forEach(section => {
          const sectionTop = section.offsetTop - 140; // немного меньше offset, чтобы срабатывать раньше
          if (pageYOffset >= sectionTop) {
              current = section.getAttribute('id');
          }
      });

      if (current) {
          document.querySelectorAll('.nav li').forEach(li => li.classList.remove('active'));
          const activeLink = document.querySelector('.nav a[href="#' + current + '"]');
          if (activeLink) {
              activeLink.closest('li').classList.add('active');
          }
      }
  });


// Если пришли с другой страницы с хешем в URL
window.addEventListener('DOMContentLoaded', () => {
    const hash = window.location.hash.substring(1); // убираем #
    if (hash) {
        const target = document.getElementById(hash);
        if (target) scrollToTarget(target);
    }
});
  document.querySelectorAll('.about__btn, .slideshow__btn').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const target = document.getElementById(targetId);

      if (target) {
        const headerOffset = 130; // высота фиксированного хедера
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
  $(window).scroll(function() {
      if ($(this).scrollTop() > 0) {
          $('.header').addClass('fixed');
      } else {
          $('.header').removeClass('fixed');
      }
  });
  $(window).scroll(function() {
      if ($(this).scrollTop() > 400) {
          $('.arrow-up').fadeIn();
      } else {
          $('.arrow-up').fadeOut();
      }
  });
  $('.arrow-up').click(function() {
      $('html, body').animate({
          scrollTop : 0
      }, 800);
      return false;
  });
  $(".popup__close, .popup__overlay").click(function() {
    $(".popup").removeClass('show');
  });
  $(".mobile-opener").click(function() {
    $(this).toggleClass('active');
    $(".nav").toggleClass('show');
  });
  $(".about__video-overlay").click(function() {
    $(this).css('display', 'none');
  });
  $(".popup-opener").click(function() {
    $(".popup").addClass('show');
    $('.popup__title').text($(this).data('text'));
    $('.nav').removeClass('show');
    $('.mobile-opener').removeClass('active');
  });
  if ($('.countdown').length) {
    function updateCountdown() {
      let now = new Date();

      // конец месяца = первый день следующего месяца в 00:00
      let nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
      let diff = nextMonth - now;

      if (diff <= 0) {
        // если месяц закончился, сразу обновляем на следующий
        nextMonth = new Date(now.getFullYear(), now.getMonth() + 2, 1);
        diff = nextMonth - now;
      }

      let days = Math.floor(diff / (1000 * 60 * 60 * 24));
      let hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      let minutes = Math.floor((diff / (1000 * 60)) % 60);
      let seconds = Math.floor((diff / 1000) % 60);

      document.getElementById("days").textContent = String(days).padStart(2, "0");
      document.getElementById("hours").textContent = String(hours).padStart(2, "0");
      document.getElementById("minutes").textContent = String(minutes).padStart(2, "0");
      document.getElementById("seconds").textContent = String(seconds).padStart(2, "0");
    }

    setInterval(updateCountdown, 1000);
    updateCountdown();
  };

  if ($('#map').length) {
    function initMap() {
      const map = new google.maps.Map(document.getElementById("map"), {
        center: mapConfig.center,
        zoom: mapConfig.zoom
      });

      // создаём маркер
      new google.maps.Marker({
        position: mapConfig.marker.position,
        map: map,
        icon: {
          url: mapConfig.marker.icon,
          scaledSize: new google.maps.Size(51, 66)
        }
      });
    }

    initMap();
  };

if ($('.payment-card').length) {
  const range = document.getElementById("range");
  const fill = document.querySelector(".range-fill");
  const price = document.getElementById("price");

  function updateRange() {
    const min = +range.min;
    const max = +range.max;
    const val = +range.value;

    const percent = ((val - min) / (max - min)) * 100;
    fill.style.width = percent + "%";

    price.textContent = val.toLocaleString("en-US");
  }

  range.addEventListener("input", updateRange);
  updateRange();
}

if ($('.calc-section').length) {
  document.querySelectorAll('.calc-section').forEach(section => {
    const range = section.querySelector('input[type="range"]');
    const fill = section.querySelector('.range-fill');
    const price = section.querySelector('.price');

    function updateRange() {
      const min = +range.min;
      const max = +range.max;
      const val = +range.value;

      const percent = ((val - min) / (max - min)) * 100;
      fill.style.width = percent + "%";
      price.textContent = val.toLocaleString("en-US");
    }

    range.addEventListener("input", updateRange);
    updateRange();
  });
}
global.customSelect = new Select();
sliders();

});



// WEBPACK FOOTER //
// app/scripts/index.js